import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Avatar from "@material-ui/core/Avatar";
import { useSelector } from "react-redux";
import { Tooltip } from "@material-ui/core";

const AvatarView = ({
  displayName,
  alt,
  src,
  className,
  onClick,
  id,
  typeGroup = false,
  showCircle = false,
  showToolTip = false,
  ...props
}) => {
  let result = "";
  let tokens = [];
  const group = useSelector((state) => state.messagingManagement.group);
  const refreshAvatar = useSelector(
    (state) => state.messagingManagement.refreshAvatar
  );
  const [number, setNumber] = useState(refreshAvatar);

  if (displayName && typeof displayName.split === "function") {
    tokens = displayName.split(/\s/);
  }
  for (let i = 0; i < tokens.length; i++) {
    if (i < 2) result += tokens[i].substring(0, 1).toUpperCase();
  }
  if (id && id.length > 8 && !typeGroup)
    src = [
      window.config.managementServiceUrl,
      "user/photo?id=",
      id,
      "&avatar?t=" + number,
    ].join("");
  else if (typeGroup && id && id.length > 8)
    src = [
      window.config.managementServiceUrl,
      "messagingGroup/",
      id,
      "/avatar?t=" + number,
    ].join("");

  useEffect(() => {
    setNumber(refreshAvatar);
  }, [refreshAvatar]);
  return (
    <Tooltip title={showToolTip ? displayName : ""}>
      {showCircle ? (
        <Avatar
          style={{ border: "3px solid purple" }}
          className={className}
          alt={alt}
          src={src}
          onClick={onClick}
        >
          {result}
        </Avatar>
      ) : (
        <Avatar className={className} alt={alt} src={src} onClick={onClick}>
          {result}
        </Avatar>
      )}
    </Tooltip>
  );
};

AvatarView.propTypes = {
  displayName: PropTypes.string,
};

export default AvatarView;
